import { render } from "./InstancesPage.vue?vue&type=template&id=7fb70f60&scoped=true"
import script from "./InstancesPage.vue?vue&type=script&lang=js"
export * from "./InstancesPage.vue?vue&type=script&lang=js"

import "./InstancesPage.vue?vue&type=style&index=0&id=7fb70f60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb70f60"]])

export default __exports__